import type { Href } from "expo-router";
import type { ReactNode } from "react";

/**
 * Nothing on web: the browser's own back leads off a public page there, and an anonymous visitor
 * who arrived from a QR scan has no previous page in this app to return to.
 */
export function PublicBackButton(_props: { fallback?: Href; }) {
  return null;
}

/**
 * `undefined` rather than a component that renders nothing: an empty `headerLeft` is still an
 * override and would take away the stack's own back chevron.
 */
export function publicBackHeaderLeft(_fallback: Href): (() => ReactNode) | undefined {
  return undefined;
}
